import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { REGULAR_CLASS } from 'constants/contentTypes';
import InstructorProfile from 'components/InstructorProfile';
import { getLiveTopicInfo } from 'reduxModules/live/selector';

import useStyles from 'hooks/useStyles';

import styles from './Instructor.scss';

const Instructor = () => {
  useStyles(styles);
  const { t } = useTranslation(['live']);
  const { instructors } = useSelector(getLiveTopicInfo);

  return (
    <section className={styles.root}>
      <h2 className={styles.title}>{t('topic.overview.detail.instructor')}</h2>
      <InstructorProfile
        instructors={instructors}
        contentType={REGULAR_CLASS}
      />
    </section>
  );
};

export default Instructor;
